import { render, staticRenderFns } from "./AddressPostalRadioField.vue?vue&type=template&id=1006dd7a"
import script from "./AddressPostalRadioField.vue?vue&type=script&lang=js"
export * from "./AddressPostalRadioField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports